import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeProvider } from 'styled-components'
import loadable from '@loadable/component'
import theme from '../utils/theme'
import NavbarV2 from './Navbar'
import Footer from './Footer'
import Loader from './loader'

import './layout.css'


const Wrapper = styled.div``

const LayoutV2 = ({ children }) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Wrapper>{children}</Wrapper>
        <NavbarV2 />
        <Footer />
      </ThemeProvider>
    </>
  )
}

LayoutV2.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutV2
